import React from "react";
import { ActionCard } from "../../components/molecules/ActionCard";

export function UpsellCardBase({
  actions,
  content,
  heading,
}: {
  heading: JSX.Element;
  content: JSX.Element;
  actions: JSX.Element;
}) {
  return (
    <ActionCard
      cardContent={
        <>
          {heading}
          {content}
          {actions}
        </>
      }
    />
  );
}
